<div>
  <app-question-categories-filter
    (search)="searchQuestionCategories($event)">
  </app-question-categories-filter>
  <mat-divider></mat-divider>
  <app-question-categories-table *ngIf="questionCategories"
    [questionCategories]="questionCategories.content"
    [pageSize]="questionCategories.size"
    [totalElements]="questionCategories.totalElements"
    (loadQuestionCategories)="loadQuestionCategories($event)">
  </app-question-categories-table>
</div>
